import { RotateCw } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "./ui/button";

/**
 * Shown instead of an empty state when the server call failed, so "nothing here" never stands in
 * for "couldn't ask". Staff draw real conclusions from empty lists (no such buyer, no sales).
 */
export function LoadError({ what, error, onRetry, className }: { what: string; error: unknown; onRetry?: () => void; className?: string }) {
  const message = error instanceof Error ? error.message : String(error ?? "unknown error");
  return (
    <div role="alert" className={cn("flex flex-wrap items-center gap-2 px-4 py-3 text-sm text-[var(--color-danger-fg)]", className)}>
      <span>
        Couldn't load {what}: {message}
      </span>
      {onRetry && (
        <Button size="sm" variant="outline" onClick={() => onRetry()}>
          <RotateCw /> Retry
        </Button>
      )}
    </div>
  );
}
